import React from 'react';
import { UiSingleRow, UiCol, UiRowContainer } from '../../../_uiComponents/grid-container/GridContainer';
import { UiCardTitle } from '../../../_uiComponents/common/UiCardTitle';
import UiTopSelect from '../../../_uiComponents/common/UiTopSelect';
import { UiContentCol } from '../../../_uiComponents/common/UiPageElements';
import BarChart from './BarChart';
import { useSelector } from 'react-redux';


export default function NationalPerformanceChart(props) {

    const { teamPerformance } = useSelector((state) => {
        return { teamPerformance: state.campaign.teamPerformance };
    });

    return (
        <>
            <UiRowContainer fluid="fluid" >
                <UiCol lg="12" className="sb-national-performance-chart ">              
                        <div className='sb-national-performance-wr'>
                            <UiSingleRow>
                                <UiCol lg="12">
                                    <UiCardTitle title="Current National Top Performer" />
                                </UiCol>
                                <UiCol lg="4">
                                    <h5>How do you compare?</h5>
                                    <p>This graph celebrates the highest performers during this quarter in each of the product categories. </p>
                                    <p>We're here to support you every step of the way with expert insights and invaluable tips for success. Keep your eyes peeled for exciting updates and insider advice right here on the ÉQUIPE site.</p>

                                </UiCol>
                                <UiCol lg="8">
                                    <div className='sb-national-performance-chart-bg'>
                                        <BarChart
                                            teamPerformance={teamPerformance?.wearAndTearNationalPerformanceData}
                                        />
                                    </div>
                                </UiCol>
                            </UiSingleRow>
                        </div>               
                </UiCol>
            </UiRowContainer>

        </>
    )
}
